<template>
  <div class="slide zoom" v-parallax-fit="parallax">
    <div class="maze"></div>
    <div class="hand"></div>
  </div>
</template>

<script>
export default {
  name: 'slide14_3',
  data() {
    return {
      parallax: [
        {
          start: 13200,
          end: 13700,
          fromStyle: { transform: 'translateY(1800px) translateX(-800px) rotateZ(-45deg)' },
          toStyle: { transform: 'translateY(0px) translateX(0px) rotateZ(0deg)' },
          easing: 'linear'
        },
        {
          start: 15000,
          end: 15500,
          fromStyle: { transform: 'translateY(0px) translateX(0px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(1800px) translateX(-800px) rotateZ(-45deg)' },
          easing: 'linear'
        },
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: fixed;
    transition: 0.5s;
    z-index: 5;
    left: calc(50% - 255px);
    top: calc(50% - 480px);
    transform-origin: center;
    @media(max-width: 600px) {
      left: calc(50% - 225px);
      top: calc(50% - 260px);
    }

    .maze {
      position: absolute;
      background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/14_PaperMaze_3.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 525px;
      height: 512px;
      left: 0;
      top: 310px;
      @media(max-width: 600px) {
        width: 250px;
        left: 71px;
        top: calc(50% - 260px);
      }
    }

    .hand {
      position: absolute;
      transform-origin: center;
      background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/14_Hand_3.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 301px;
      height: 1190px;
      left: -199px;
      top: 380px;
      transform: rotateZ(29deg);
      @media(max-width: 600px) {
        top: calc(50% - 240px)
      }
    }
}
</style>
